import { observer } from 'mobx-react';
import React from 'react';
import translate from '../Translate';
import { toJS } from 'mobx';
import LoadMore from '../Common/LoadMore';


const StudentAssignment = observer(class StudentAssignment extends React.Component {
  constructor(props) {
    super();

    // Set the initial state
    this.state = {
      examEnrollments: toJS(props.examEnrollments),
      added: [],
      removed: [],
    }

    // Bind this to functions
    this.verifyChecked = this.verifyChecked.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.applyColorIndicator = this.applyColorIndicator.bind(this)

  }

  componentDidMount() {
    const {ExamStore} = this.props.store;
    this.resetFilters()
    ExamStore.getEnrollments(this.props.exam.sid, null, true)
  }

  onCheck(e, key){
    let added = this.state.added.includes(key.sid)
    let removed = this.state.removed.includes(key.sid)

    if(e.target.checked){
      // Only assign to exams that are unassigned
      if(!added && key.session.status === 'Not Assigned'){
        let updated = [...this.state.added, key.sid]
        this.setState({added: [...updated]})
      } if(removed) {
        let filtered = this.state.removed.filter(sid => sid !== key.sid)
        this.setState({removed: filtered})
      }
    } else {
      // only remove from array if it's not assigned
      if(!removed && key.session.status !== 'Not Assigned'){
        let updated = [...this.state.removed, key.sid]
        this.setState({removed: updated})
      } else if(added){
        let filtered = this.state.added.filter(sid => sid !== key.sid)
        this.setState({added: filtered})
      }
    }
  }

  applyColorIndicator(key){
    if(this.state.added.find(sid => key.sid === sid)) {
      return 'added'
    } else if (this.state.removed.find(sid => key.sid === sid)) {
      return 'removed'
    }
  }


  applyFilters(e) {
    const {ExamStore} = this.props.store;
    const examSid = this.props.exam.sid;

    e.preventDefault();

    let filters = {};


    const name = ExamStore.filterParams.name;
    const assigned = ExamStore.filterParams.assigned;

    if(name){
      filters.name = name;
    }

    if(assigned){
      filters.assigned = assigned
    }


    if( assigned || name) {
      ExamStore.getEnrollments(examSid, filters, true);
      this.setState({examEnrollments: ExamStore.examEnrollments});
    } else {
      this.resetFilters();
    }
  }

  resetFilters(){
    const {ExamStore} = this.props.store;
    const examSid = this.props.exam.sid;


    ExamStore.filterParams.name = '';
    ExamStore.filterParams.assigned = '';
    ExamStore.filterParams.fname  = '';
    ExamStore.filterParams.lname = '';
    ExamStore.filterParams.status = '';
    ExamStore.getEnrollments(examSid)
  }

  verifyChecked(key) {
    if(key.session.status !== 'Not Assigned'){
      if(!this.state.removed.includes(key.sid)){
        // If orginal status is anything but not assigned and it is not present in the removed array then it should be checked
        return true;
      } else {
        // Included in removed array, return not checked/false
        return false;
      }
    }
    else if (key.session.status === 'Not Assigned'){
      if(!this.state.added.includes(key.sid)){
        // If original status is not assigned and it's not included in the added array  return unchecked
        return false;
      } else {
        // Included in added array return checked
        return true;
      }
    }
  }

  render(){
    const {ExamStore, SessionStore} = this.props.store;
    const { translation } = this.props;
    const {examEnrollments} = ExamStore
    return(

      <div className='flex'>

          <div className='student-assignment-panel'>
            <h2>{translation.studentAssignment}</h2>
            <div className='filters'>

                  <label className="meta" htmlFor="filter-name">
                    {translation.name}
                  </label>
                  <input
                    type="text"
                    id="filter-name"
                    placeholder={translation.name}
                    onChange={(e) => {ExamStore.filterParams.name = e.target.value; this.applyFilters(e, true)}}
                    value={ExamStore.filterParams.name}

                  />
                  <label className="select panel__filter" htmlFor="filter-status">
                    <select
                      id="filter-status"
                      onChange={(e) => {ExamStore.filterParams.assigned = e.target.value; this.applyFilters(e, true)}}
                      defaultValue={'All'}
                    >
                      <option value="">{translation.filter.status_all}</option>
                      <option value={true}>{translation.assigned}</option>
                      <option value={false}>{translation.not_assigned}</option>
                    </select>
                  </label>

            </div>

            <div className='table-container'>
              <table>
                <thead>
                <tr>
                  <th id="heading-name" className="subtitle" scope="col">{translation.student}</th>
                  <th id="heading-actions" className="subtitle table-action" scope="col">{translation.assigned_to_exam}</th>
                </tr>
                </thead>
                <tbody>
                {examEnrollments.map(
                  (key, i) => {
                    if (true
                    ) {
                      return ([
                        <tr key={i} className={this.applyColorIndicator(key)}>
                          <td aria-labelledby="heading-name">
                            <div className="cell-wrap">
                              {key.lastName}, {key.firstName}
                            </div>
                          </td>
                          <td className='number checkbox'>
                            <input id={`${i}-checkbox`} type='checkbox' className="checkbox-input" checked={this.verifyChecked(key)} onChange={(e) => this.onCheck(e, key)}>

                            </input>
                            <label
                              className="checkbox-label checkbox-label--solo" htmlFor={`${i}-checkbox`}
                            >
                              <span className="meta">{translation.select}</span>
                            </label>
                          </td>
                        </tr>,
                      ])
                    }

                    return null;
                  }
                )}
                </tbody>
                <LoadMore
                  tableContainer={true}
                  url={ExamStore.overviewNext}
                  group={ExamStore.examEnrollments}
                  store={ExamStore}
                  resultsName="enrollments"
                  text="load more"
                  onLoad={(examEnrollments)=> {
                    this.setState({
                      examEnrollments
                    })
                  }}
                  {...this.props}
                />
              </table>
            </div>

            <div className='align-right'>
              <button className='btn' disabled={this.state.added.length === 0 && this.state.removed.length === 0} onClick={() => {

                const studentAssignConfirmation = (
                  <div className='assigned-container'>
                    <p className='heading-info'>{translation.modal.info}</p>

                    {this.state.added.length > 0 &&
                      <div>
                        <p> {translation.added}</p>

                        <ul className='assigned-list'>
                          {this.state.added.map(item => {
                            const enrollment = examEnrollments.find(enrollment => enrollment.sid === item)
                            return <li>{`${enrollment.firstName} ${enrollment.lastName}`}</li>
                          })}
                        </ul>
                      </div>
                    }

                    {this.state.removed.length > 0 &&
                      <div>
                        <p>{translation.removed}</p>

                          <ul className='assigned-list'>
                          {this.state.removed.map(item => {
                            const enrollment = examEnrollments.find(enrollment => enrollment.sid === item)
                            return <li>{`${enrollment.firstName} ${enrollment.lastName}`}</li>
                          })}
                        </ul>
                      </div>                    }
                    <div className='btn-row'>
                      <button className='btn--outline' onClick={() => {SessionStore.alternateModalClose()}}>
                        {translation.cancel}
                      </button>
                      <button className='btn' onClick={() => {
                        const callback = () => {
                          this.resetFilters()
                          ExamStore.getEnrollments(this.props.exam.sid, null, true);
                          this.setState({added: [], removed: []});
                          SessionStore.alternateModalClose();
                        }
                        ExamStore.updateExamAssignment(this.state.added, this.state.removed, this.props.exam.sid, callback);

                      }}>
                        {translation.confirm}
                      </button>

                    </div>
                  </div>
                );
                SessionStore.modalContent = studentAssignConfirmation;
                SessionStore.hideTimes = true;
                SessionStore.showModal = true;
                SessionStore.modalSmall = true;
                SessionStore.modalHeader = 'Assignment Confirmation'
                if(this.state.added.length === 0 || this.state.removed.length === 0){
                  SessionStore.modalShort = true;
                  SessionStore.modalMediumShort = false;
                } else {
                  SessionStore.modalMediumShort = true;
                  SessionStore.modalShort = false;
                }
                SessionStore.modalLoaded = true;
              }}>
                {translation.save}
              </button>
            </div>

          </div>
      </div>

    )
  }
})
export default translate('StudentAssignment')(StudentAssignment);




// WEBPACK FOOTER //
// ./src/app/components/Modules/StudentAssignment.js